import {
  createPlugin,
  createReactExtension,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef, surveyRouteRef } from './routes';

export const surveyingPlugin = createPlugin({
  id: 'surveying',
  routes: {
    root: rootRouteRef,
    survey: surveyRouteRef
  },
});

export const SurveyingPage = surveyingPlugin.provide(
  createRoutableExtension({
    name: 'SurveyingPage',
    component: () =>
      import('./components/SurveyingPage').then(m => m.SurveyingPage),
    mountPoint: rootRouteRef,
  }),
);
export const SingleSurveyPage = surveyingPlugin.provide(
  createRoutableExtension({
    name: 'SingleSurveyPage',
    component: () =>
      import('./components/SingleSurveyPage').then(m => m.SingleSurveyPage),
    mountPoint: surveyRouteRef,
  }),
);

export const SurveyEntityLayout = surveyingPlugin.provide(
  createReactExtension({
    name: 'SurveyEntityLayout',
    component: {
      lazy: () => import('./components/SurveyEntityLayout').then(m => m.SurveyEntityLayout)
    }
  }),
);
